import { render, staticRenderFns } from "./LabelNumberField.vue?vue&type=template&id=0d720ae9&"
import script from "./LabelNumberField.vue?vue&type=script&lang=js&"
export * from "./LabelNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports